import { lowerCaseFirstLetter } from './lowerCaseFirstLetter';
import { removeLeadingSlash } from './removeLeadingSlash';

export const StringService = {
  lowerCaseFirstLetter,
  removeLeadingSlash,
};
